import { html, repeat, ref } from '@microsoft/fast-element';
import { VPPA_COLUMNS } from './column-config';
import type { RemodelOperationalProject } from './remodel-operational-projects';

export const RemodelOperationalProjectTemplate = html<RemodelOperationalProject>`
  <div class="container">
    <div class="remodel-project-description">
      Does the Operational Project you have created match any of the following selections?
      <br />
      <br />
      By selecting a Project from the list below, pre-trade key metrics will utilize observed
      historical generation and a modeled generation forecast. If none of the Projects below match
      your entry, pre-trade key metrics will utilize modeled historical and forecast generation.
      <br />
      <br />
    </div>
    <div class="container">
      <zero-grid-pro
        class="grid-styles"
        only-template-col-defs
        sideBar=""
        rowSelection="single"
        @onGridReady="${(x) => x.onGridReady()}"
        ${ref('remodelProjectsGrid')}
      >
        ${repeat(
          (x) => VPPA_COLUMNS(x),
          html`
            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
          `
        )}
      </zero-grid-pro>
    </div>
  </div>
`;
